import { Link } from 'react-router-dom'
import { useDispatch } from "react-redux";
import { openPopup} from "../../store/popupSlice";
import Breadcrumb from '../../component/Breadcrumb';

const breadcrumbData = {
  newClass:"center-breadcrumb white-breadcrumb",
  list:[
    {
      page:"Home",
      slug:"/"
    },
    {
      page:"web app development",
      slug:""
    },
  ]
}

export default function WebAppBanner() {
  const dispatch=useDispatch();
  return (
    <>
      <section className="custom-app-banner web-app-banner header-gap">
        <div className="custom-banner-img">
          <img src="./assets/home/web-app-banner.webp" alt="banner" className='img-responsive'/>
        </div>

        <div className="custom-app-head text-center">
          <Breadcrumb breadcrumbData={breadcrumbData}/>
          <h1 className="heading center-heading">Your Future Software <br /> Development Partner</h1>
          <p className="sub-heading">Located between Manchester and Cheshire, we’ve delivered top-tier web <br /> development, applications, and custom software solutions for over 15 years.  
          </p>
          <small>21 Days Free Trial | No Credit Card Required</small>
          <Link  onClick={() => dispatch(openPopup())}  className="default-btn animated-btn">Contact us about your project today!
          </Link> 
        </div>
        
      </section>
    </>
  )
}
